import { Request } from '@/classes/Request.ts'

export interface EnrollmentEmailQuickpayLinkResponse {
  success: boolean
  failure_reason?: string
  validation_messages?: Record<string, string[]>
}

/**
 * Email the QuickPay payment link for this enrollment's pending-payment cart to
 * any address (e.g. a spouse/relative who will pay). The backend derives + shares
 * only this invitation's own live cart guid. Token-authenticated, public.
 * POST /api/enrollment/invitation/{token}/email-quickpay-link
 */
export const enrollmentEmailQuickpayLink = async (
  token: string,
  email: string
): Promise<EnrollmentEmailQuickpayLinkResponse> => {
  const response = await new Request().post(
    `/api/enrollment/invitation/${encodeURIComponent(token)}/email-quickpay-link`,
    { email }
  )
  return response.data
}
